export default {
    methods: {
        download(blob, name, type) {
            const fileURL = window.URL.createObjectURL(new Blob([blob]));
            const fileLink = document.createElement('a');
            fileLink.href = fileURL;
            fileLink.setAttribute('download', type ? `${name}.${type}`:`${name}.pdf`);
            fileLink.setAttribute('target', '_blank');
            document.body.appendChild(fileLink);
            fileLink.click();
            fileLink.remove();
        },

        async downloadFromUrl(docUrl,name, type) {
            const res = await fetch(docUrl);
            const blob = await res.blob();
            const fileName = `${name}.${type}`;
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
        },

        async printOnSiteFromUrl(docUrl) {
            const res = await fetch(docUrl);
            const blob = await res.blob();
            const url = window.URL.createObjectURL(blob);
            const iframe =  document.createElement('iframe');
            document.body.appendChild(iframe);

            iframe.style.display = 'none';
            iframe.src = url;
            iframe.onload = function() {
            setTimeout(function() {
                iframe.focus();
                iframe.contentWindow.print();
            }, 1);
            };
        },

        print(blob) {
            const fileURL = window.URL.createObjectURL(
                new Blob([blob], { type: 'application/pdf' })
            );
            const fileLink = document.createElement('a');
            fileLink.href = fileURL;
            fileLink.setAttribute('target', '_blank');
            document.body.appendChild(fileLink);
            fileLink.click();
        },

        printOnSite(blob) {
            var newBlob = new Blob([blob], {type: 'application/pdf'});
            var blobURL = URL.createObjectURL(newBlob);

            const iframe =  document.createElement('iframe');
            document.body.appendChild(iframe);

            iframe.style.display = 'none';
            iframe.src = blobURL;
            iframe.onload = function() {
            setTimeout(function() {
                iframe.focus();
                iframe.contentWindow.print();
            }, 1);
            };
        }
    }
}
